module.exports = __webpack_public_path__ + "1.5.0-unryo/img/offline-unknown-1.f57f892f.svg";